export const subMenuBackground = "#b4bdc9ff"; // darker/lighter than sidebar
export const subMenuText = "#202e41ff";
export const subMenuHoverText = "#7a8ca4ff";

export const subMenuSelectedBackground = "#d8dce3ff"; // darker/lighter than sidebar
export const subMenuSelectedText = "#202e41ff";

// Main Content Area
export const mainContentBackground = "#e1f1fd"; // very light blue for a soft background
export const mainContentText = "#4663ac"; // medium blue text for readability

// Table styles
export const theadBorder = "#b6bfc9ff"; // soft blue border
export const theadBackground = "#838797ff"; // bright blue header
export const theadText = "#171849ff"; // very light text

export const tbodyBorder = "#BFDBFE"; // soft row borders
export const tbodyBackground = "#EFF6FF"; // very light blue background
export const tbodyText = "#1E3A8A"; // medium blue text
